<script setup lang="ts">
definePageMeta({
    layout: 'catalog',
    name: 'master_category'
})

const route = useRoute()


enum CatalogModeEnum {
    geo = 'geo',
    list = 'list'
}
const catalogMode = ref(CatalogModeEnum.list)

/*onMounted(async () => {
    if(route.query?.mode === CatalogModeEnum.geo){
        catalogMode.value = CatalogModeEnum.geo
    } else {
        catalogMode.value = CatalogModeEnum.list
    }
})*/

watch(() => route.query?.mode, () => {
    if(route.query?.mode === CatalogModeEnum.geo){
        catalogMode.value = CatalogModeEnum.geo
    } else {
        catalogMode.value = CatalogModeEnum.list
    }
})

onMounted(() => {
    if(route.query?.mode === CatalogModeEnum.geo){
        catalogMode.value = CatalogModeEnum.geo
    } else {
        catalogMode.value = CatalogModeEnum.list
    }
})

const isClient = computed(() => {
    return process.client
})

</script>

<template>
    <div class="">
        <client-only v-if="catalogMode === CatalogModeEnum.geo && isClient">
            <PagesCatalogGeoCatalogPage />
        </client-only>
        <PagesCatalogPage v-else />
    </div>
</template>